import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import { Container, Reveal, SectionHead } from "@/components/Motion";
import { IMAGES, WHY_EVovLEX } from "@/data/content";

export default function WhyEvovlex() {
  return (
    <>
      <SEO
        title="Why Choose EVOVLEX IT | Business-Focused, Security-First Technology"
        description="Why EVOVLEX IT: business-focused technology, security-first approach, scalable solutions, innovation driven, end-to-end expertise and long-term partnership."
      />
      <PageHero
        eyebrow="Why EVOVLEX IT"
        titleLines={[
          "Why Choose",
          { node: <span className="text-gradient-brand">EVOVLEX IT?</span> },
        ]}
        sub="Six principles that shape how we design, build and support technology for your business."
        image={IMAGES.techForward}
      />

      <section data-testid="why-editorial-section" className="bg-white py-20 lg:py-28">
        <Container>
          <div className="flex flex-col">
            {WHY_EVovLEX.map((w, i) => (
              <Reveal key={w.title} delay={0.05}>
                <div
                  data-testid={`why-row-${w.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className={`group grid items-center gap-6 border-t border-slate-200 py-10 transition-colors duration-300 hover:bg-slate-50/70 md:grid-cols-12 md:gap-10 lg:py-14 ${
                    i === WHY_EVovLEX.length - 1 ? "border-b" : ""
                  }`}
                >
                  <div className="md:col-span-2">
                    <span className="font-display text-5xl font-extrabold tracking-tight text-slate-100 transition-colors duration-300 group-hover:text-cyan-500/40 lg:text-6xl">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                  </div>
                  <div className={`md:col-span-6 ${i % 2 === 1 ? "md:order-3 md:col-start-7" : ""}`}>
                    <h2 className="font-display text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
                      {w.title}
                    </h2>
                    <p className="mt-3 max-w-xl text-base leading-relaxed text-slate-600">{w.desc}</p>
                  </div>
                  <div className={`hidden md:col-span-4 md:flex ${i % 2 === 1 ? "md:order-2 md:col-start-3 md:justify-start" : "md:justify-end"}`}>
                    <span className="flex h-20 w-20 items-center justify-center rounded-2xl border border-slate-200 bg-white text-evo-blue shadow-sm transition-all duration-300 group-hover:border-cyan-500/40 group-hover:shadow-lg group-hover:shadow-blue-600/10">
                      <w.icon className="h-9 w-9" strokeWidth={1.5} />
                    </span>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.1}>
            <div className="relative mt-16 overflow-hidden rounded-3xl bg-navy-950 px-8 py-14 text-center grain sm:px-12">
              <div className="absolute inset-0 grid-lines-dark" aria-hidden="true" />
              <div className="relative">
                <h2 className="mx-auto max-w-2xl font-display text-2xl font-bold text-white sm:text-3xl">
                  Technology. Security. Innovation. Delivered as one partnership.
                </h2>
                <p className="mx-auto mt-4 max-w-xl text-sm text-slate-400 sm:text-base">
                  Let's turn your technology challenges into opportunities.
                </p>
                <Link
                  to="/contact"
                  data-testid="why-page-cta"
                  className="mt-8 inline-flex items-center gap-2 rounded-lg bg-gradient-to-r from-blue-600 to-cyan-500 px-7 py-4 text-sm font-semibold text-white shadow-lg shadow-blue-600/25 transition-all duration-300 hover:-translate-y-0.5"
                >
                  Start the Conversation
                  <ArrowRight className="h-4 w-4" />
                </Link>
              </div>
            </div>
          </Reveal>
        </Container>
      </section>
    </>
  );
}
